import React, { useEffect } from "react";
import { SitebarCollapsable } from "components/SitebarCollapsable";
import { useAuth, useTopic, useSearch, useQuery } from "hooks";
import { LoginButton } from "account/Login";
import { Badge } from "reactstrap";
import { CallToAction } from "components/CallToAction";
import { FA } from "components/FA";
import { NotFound, Loading } from "components/Utils";
import { TopicSelector } from "components/topic/TopicSelector";
import styles from "./Personal.module.css";

const Personal = () => {
  const auth = useAuth();
  const {
    setQuery,
    actions: { execute },
  } = useSearch();
  const { topics, current, queries, actions } = useTopic();
  const { query, actions: qActions } = useQuery();
  useEffect(() => {
    if (auth.user) {
      actions.fetch();
    }
  }, [actions, auth.user]);
  return (
    <SitebarCollapsable header="Personal" toggled>
      {auth.user ? (
        <dl className={styles.list}>
          <dt className={styles.label}>Topic:</dt>{" "}
          <dd className={styles.topic}>
            <TopicSelector
              topics={topics}
              value={current ? current.id : "none"}
              onTopicSelect={actions.current}
              onTopicDelete={actions.delete}
            />
            <p className={styles.description}>
              {current ? (
                current.description ? (
                  current.description
                ) : (
                  <NotFound items="description" />
                )
              ) : (
                "Saved queries, not assigned to a topic, are listed below."
              )}
            </p>
          </dd>
          <hr className={styles.separator} />
          <dt className={styles.label}>Queries:</dt>
          <dd className={styles.queries}>
            {queries == null ? (
              <div className={styles.wrapper}>
                <Loading />
              </div>
            ) : queries.length > 0 ? (
              queries.map((q) => {
                const showQuery = () =>
                  qActions.current(
                    !query || (query && query.id !== q.id) ? q : null
                  );
                const queryActions = [
                  {
                    value: "show",
                    label: "Show",
                    icon: "eye",
                    action: showQuery,
                  },
                  {
                    value: "search",
                    label: "Search",
                    icon: "search",
                    action: () => setQuery(q.parameters) || execute(),
                  },
                  {
                    value: "delete",
                    label: "Delete",
                    icon: "trash",
                    action: () => qActions.delete(q.id),
                  },
                ];
                return (
                  <div
                    className={`${styles.query}${
                      query && query.id === q.id ? " active" : ""
                    }`}
                    key={q.id}
                  >
                    <span
                      title={q.parameters.query}
                      className={styles.queryString}
                      onClick={showQuery}
                    >
                      {q.parameters.query}
                    </span>
                    <Badge color="light" pill>
                      {(q.report.resultset.length || 0).toLocaleString()}/
                      {(q.report.docsCount || 0).toLocaleString()}
                    </Badge>
                    <CallToAction
                      className={styles.action}
                      size="sm"
                      color="action"
                      caret={false}
                      items={queryActions}
                      emptyLabel={
                        <FA title="Click to select action" icon="ellipsis-v" />
                      }
                    />
                  </div>
                );
              })
            ) : (
              <div className={styles.wrapper}>
                <NotFound items="Topics" />
              </div>
            )}
          </dd>
        </dl>
      ) : (
        <LoginButton />
      )}
    </SitebarCollapsable>
  );
};

export { Personal };
